import { InputHTMLAttributes } from 'react';
import styles from './UniversalToggle.module.css';

export interface UniversalToggleProps extends Omit<InputHTMLAttributes<HTMLInputElement>, 'type'> {
	checked?: boolean;
	onChangeToggle?: (checked: boolean) => void;
	disabled?: boolean;
	isLoading?: boolean;
}

export const UniversalToggle = ({
	checked = false,
	onChangeToggle,
	disabled = false,
	isLoading = false,
	className,
	...props
}: UniversalToggleProps) => {
	const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		if (!disabled && !isLoading) {
			onChangeToggle?.(event.target.checked);
		}
	};

	return (
		<label className={`${styles.switch} ${className || ''}`}>
			<input
				type="checkbox"
				checked={checked}
				onChange={handleChange}
				disabled={disabled || isLoading}
				{...props}
			/>
			<span className={`${styles.slider} ${isLoading ? styles.loading : ''}`}>
				{isLoading && <span className={styles.spinner} />}
			</span>
		</label>
	);
};
